export default "__VITE_ASSET__BCt24FzB__"